import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

import { campaign } from '@/constants/campaign'

// The title and share description are edited in src/constants/campaign.ts.
export const siteConfig: SiteConfig = {
    name: campaign.pageTitle,
    description: campaign.shareDescription,
    url: getOrigin(),
    indexable: campaign.allowSearchIndexing
}
